<div
  #container
  class="main flex flex-col justify-between"
  [style.height.px]="windowHeight"
  (window:resize)="getWindowHeight()"
>
  <div class="header flex justify-between items-center">
    <span data-cy="sidenav-title">{{ title }}</span>
    <rk-icon-button
      (click)="cancelled.emit($event)"
      color="white"
      faIcon="fa-times"
      [size]="24"
    ></rk-icon-button>
  </div>

  <div
    class="content flex-1"
    [ngClass]="{ 'no-scroll': !enableScrollbar }"
    rkPerfectScrollbar
    #mainContent
  >
    <ng-content></ng-content>
  </div>

  <ng-container *ngIf="!showLinkForCancel; else linkCancel">
    <div class="footer" *ngIf="!hideBottom">
      <rk-button
        data-cy="sidenav-cancel-button"
        *ngIf="!(isSaving$ | async)"
        btnStyle="flat"
        [label]="cancelText || ('MODAL.DEFAULT.CANCEL' | translate)"
        (click)="cancelled.emit($event)"
      ></rk-button>
      <rk-loader [isLoading]="isSaving$ | async" [size]="25"></rk-loader>

      <rk-hotkeys-help-tooltip [disable]="disabledSubmit">
        <rk-button
          class="submit-sidenav"
          data-cy="sidenav-submit-button"
          [type]="'submit'"
          [label]="submitText || ('MODAL.DEFAULT.SAVE' | translate)"
          (click)="submitted.emit($event)"
          [disabled]="disabledSubmit || (isSaving$ | async)"
        ></rk-button>
      </rk-hotkeys-help-tooltip>
    </div>
  </ng-container>

  <ng-template #linkCancel>
    <div class="footer">
      <rk-button
        data-cy="sidenav-cancel-button"
        *ngIf="!(isSaving$ | async)"
        btnStyle="link"
        [label]="cancelText || ('MODAL.DEFAULT.CANCEL' | translate)"
        (click)="actionInsteadOfCancel.emit($event)"
      ></rk-button>
      <rk-loader [isLoading]="isSaving$ | async" [size]="25"></rk-loader>
      <rk-button
        data-cy="sidenav-submit-button"
        [type]="'submit'"
        [label]="submitText || ('MODAL.DEFAULT.SAVE' | translate)"
        (click)="submitted.emit($event)"
        [disabled]="disabledSubmit || (isSaving$ | async)"
      ></rk-button>
    </div>
  </ng-template>
</div>
